import { lazy, Suspense } from "react";
import { useLottieAnimation } from "../../hooks/CmsHooks";
import { cmsAssetUrl } from "../../utils/CmsUtils";

const LottieAnimation = lazy(() => import("../LottieAnimation"));

const GuideAnimation = ({ _id }) => {
  const animation = useLottieAnimation(_id);
  //console.log("animSettings", animSettings);
  const loop = true; //animSettings.animation ? animSettings.loop : false;
  return animation?.file?.path ? (
    <Suspense>
      <LottieAnimation
        path={cmsAssetUrl(animation.file.path)}
        loop={loop}
        autoplay={loop}
        width={"100%"}
        style={{
          display: "block",
          position: "absolute",
          top: "0px",
          bottom: "0px",
          left: "0px",
          right: "0px",
          height: "100%",
          width: "100%"
        }}
      />
    </Suspense>
  ) : null;
};

export default GuideAnimation;
